/**
 * Removes a question step from the DOM by its step name and updates step IDs and modForm steps.
 * @param {string} stepName - The data-step-name attribute of the step to remove.
 * @example
 * removeQuestionByStepName('ReasonForStairLift'); // Removes the step with data-step-name="ReasonForStairLift"
 */
export default function removeQuestionByStepName(stepName) {
	if (!window.modForm?.opts) {
		console.warn('modForm or modForm.opts is not defined on the window object.');
		return;
	}

	const { form, stepsSelector } = window.modForm.opts;
	const stepElem = form.querySelector(`[data-step-name="${stepName}"]`);

	if (!stepElem || !stepElem.parentNode) {
		console.warn(`Step element with name "${stepName}" not found.`);
		return;
	}

	stepElem.parentNode.removeChild(stepElem);
	const steps = form.querySelectorAll(stepsSelector);

	if (steps.length === 0) {
		console.warn(`No steps found with selector "${stepsSelector}".`);
		return;
	}
	// update the steps ids
	steps.forEach((step, index) => {
		step.id = `step${index + 1}`;
	});

	// update modForm's steps if available
	window.modForm.opts.steps = steps;
	if (window.modForm.opts.formSwiperInstance) {
		window.modForm.opts.formSwiperInstance.update();
	}
}
